import { render, staticRenderFns } from "./Inscription.vue?vue&type=template&id=fab61e6e&"
import script from "./Inscription.vue?vue&type=script&lang=js&"
export * from "./Inscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports